
















































































































import {Component, Emit, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import {COURSE_STYLE_TABS_KEYS} from './course-style';
import {CourseItemData} from '@/views/media/course/components/course-item';
import {COURSE_ID} from '@/maps/enum/course';


@Component
export default class CourseStyle extends Vue {
  private titleSize: number = 20;
  private headSize: number = 14;
  private COURSE_STYLE_TABS_KEYS = COURSE_STYLE_TABS_KEYS;

  @Ref('style-store-all')
  private styleStoreAll: any;

  @Prop()
  private activeKey: COURSE_STYLE_TABS_KEYS | undefined;
  /**全局名称配置数据*/
  @Prop()
  private courseNameMaps: Map<number, string> | undefined;

  @Prop()
  private showStyle: boolean | undefined;
  /**课程对象*/
  @Prop()
  private courseItemData: CourseItemData | any;

  @Prop()
  private courseTimeMaps: Map<number, { start_hour: number; end_hour: number; start_min: number; end_min: number; }> | undefined;


  @Emit('exitStyle')
  private exitStyle() {

  }

  @Emit('titleSize')
  private titleSizeChage() {
    return Promise.resolve(this.titleSize);
  }

  @Emit('headSize')
  private headSizeChage() {
    return Promise.resolve(this.headSize);
  }


  /**课程显示切换*/
  @Emit('courseSwitch')
  private courseSwitch(e: boolean, index: number) {
    let courseItem: CourseItemData = JSON.parse(JSON.stringify(this.courseItemData));
    if (index < 0) {  //全选/全清~
      courseItem.course = courseItem.course?.map(course => {
        return Object.assign(course, {show: e});
      });
      this.styleStoreAll.checked = e;
    } else {
      courseItem.course![index].show = e;
    }
    let course = courseItem.course?.find(course => {
      return course.show;
    });
    courseItem.theme = course?.theme;
    return Promise.resolve(courseItem);
  }


  /**
   * 全局修改名称
   * @param key 所修改名称
   */
  public globalNameInput($event: string, key: string) {
    // @ts-ignore
    this.courseNameMaps!.set(key, $event.srcElement.value);
  }

  /**修改名称*/
  @Emit('globalNameSave')
  public globalNameSave(): Promise<Map<number, string>> | undefined {
    return Promise.resolve(this.courseNameMaps!);
  }

  /**全局时间修改~*/
  @Emit('')
  private globalTimeSave() {

  }


  /**全局时间重置*/
  @Emit('')
  private globalTimeReset() {

  }

  /**课程信息更改*/
  public courseMergeChage() {
    /*this.$forceUpdate();
    let clone: Node | any = this.courseItemData.ref?.cloneNode(true);
    let width: number = this.courseItemData.ref?.clientWidth;
    clone.style.width = `${width * this.courseItemData.merge}px`;
    clone.style.position = 'absolute';
    clone.style.top = '0px';
    clone.style.left = '0px';
    clone.style.margin = '0px';
    clone.style.zIndex = `${this.courseItemData.merge + 999}`;
    this.courseItemData.ref.appendChild(clone);*/
  }

  /**设置tabs*/
  public setActiveKey(key: COURSE_STYLE_TABS_KEYS) {
    this.activeKey = key;
  }

  /**课程全局名称*/
  get courseNames() {
    let ary: Array<{ title: string; value: string; key: number; }> = [];
    this.courseNameMaps?.forEach((value, key) => {
      if (!key) {
        return;
      }
      ary.push({title: COURSE_ID[key], value: value, key: key});
    });
    return ary;
  }

  /**课开始结束时间*/
  get courseTimes() {
    let ary: Array<{ title: string; start_hour: number; end_hour: number; start_min: number; end_min: number; key: number; }> = [];
    this.courseTimeMaps?.forEach((value, key) => {
      ary.push({
        title: COURSE_ID[key],
        start_hour: value?.start_hour || 0,
        start_min: value?.start_min || 0,
        end_hour: value?.end_hour || 0,
        end_min: value?.end_min || 0,
        key: key
      });
    });
    return ary;
  }

  /**简体变化*/
  @Watch('courseItemData.id')
  private courseItemDataWatch() {
    this.styleStoreAll.checked = true;
  }
}
